import { render, staticRenderFns } from "./base-textarea.vue?vue&type=template&id=299e6472"
import script from "./base-textarea.ts?vue&type=script&lang=ts&external"
export * from "./base-textarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299e6472')) {
      api.createRecord('299e6472', component.options)
    } else {
      api.reload('299e6472', component.options)
    }
    module.hot.accept("./base-textarea.vue?vue&type=template&id=299e6472", function () {
      api.rerender('299e6472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Textarea/base-textarea.vue"
export default component.exports